import { ServiceBase, IBaseEntity } from './ServiceBase';
import { get } from '../ReaderlyHttpClient';

export interface Genre extends IBaseEntity {
}

export class GenresService extends ServiceBase<Genre> {
  constructor() {
    super('genres');
  }

  async GetFiltered(searchString?: string | undefined, itemsNumber?: number) {
    const params: Record<string, string> = {};
    params.searchString = searchString ?? "";
    params.count = `${itemsNumber ?? 7}`;

    return await get<Genre[]>('genres/filters', { params });
  }
}

const genresServiceInstance = new GenresService();

export default genresServiceInstance;